import { useIntl } from 'react-intl';

import { Helmet } from '@xing-com/crate-helmet';

export const MetaData = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const title = formatMessage({
    id: 'INSIGHTS_LO_METADATA_TITLE',
  });

  const description = formatMessage({
    id: 'INSIGHTS_LO_METADATA_DESCRIPTION',
  });

  return (
    <Helmet>
      <title>{title} | XING</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};
